var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "sizeFormBar",
              attrs: {
                model: _vm.sizeForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("barDefault"),
                      expression: "showProperty('barDefault')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.adapt") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("barDefault")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.barDefault,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "barDefault", $$v)
                        },
                        expression: "sizeForm.barDefault",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.adapt")))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("barGap"),
                      expression: "showProperty('barGap')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.bar_gap") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      disabled: _vm.sizeForm.barDefault,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 5,
                      step: 0.1,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("barGap")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.barGap,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "barGap", $$v)
                      },
                      expression: "sizeForm.barGap",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineWidth"),
                      expression: "showProperty('lineWidth')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.line_width") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 10,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("lineWidth")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.lineWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "lineWidth", $$v)
                      },
                      expression: "sizeForm.lineWidth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineSymbol"),
                      expression: "showProperty('lineSymbol')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.line_symbol") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.line_symbol") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("lineSymbol")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.lineSymbol,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "lineSymbol", $$v)
                        },
                        expression: "sizeForm.lineSymbol",
                      },
                    },
                    _vm._l(_vm.lineSymbolOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineSymbolSize"),
                      expression: "showProperty('lineSymbolSize')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.line_symbol_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 20,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("lineSymbolSize")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.lineSymbolSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "lineSymbolSize", $$v)
                      },
                      expression: "sizeForm.lineSymbolSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineSmooth"),
                      expression: "showProperty('lineSmooth')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.line_smooth") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("lineSmooth")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.lineSmooth,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "lineSmooth", $$v)
                        },
                        expression: "sizeForm.lineSmooth",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.line_smooth")) + "\n        ")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("pieInnerRadius"),
                      expression: "showProperty('pieInnerRadius')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.pie_inner_radius_percent") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("pieInnerRadius")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.pieInnerRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "pieInnerRadius", $$v)
                      },
                      expression: "sizeForm.pieInnerRadius",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("pieOuterRadius"),
                      expression: "showProperty('pieOuterRadius')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.pie_outer_radius_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("pieOuterRadius")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.pieOuterRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "pieOuterRadius", $$v)
                      },
                      expression: "sizeForm.pieOuterRadius",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("radarShape"),
                      expression: "showProperty('radarShape')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.shape") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("radarShape")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.radarShape,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "radarShape", $$v)
                        },
                        expression: "sizeForm.radarShape",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "polygon" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.polygon"))),
                      ]),
                      _c("el-radio-button", { attrs: { label: "circle" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.circle"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("radarSize"),
                      expression: "showProperty('radarSize')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.radar_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("radarSize")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.radarSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "radarSize", $$v)
                      },
                      expression: "sizeForm.radarSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tablePageMode"),
                      expression: "showProperty('tablePageMode')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_page_mode"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.table_page_mode") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tablePageMode")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tablePageMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tablePageMode", $$v)
                        },
                        expression: "sizeForm.tablePageMode",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("chart.page_mode_page"),
                          value: "page",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("chart.page_mode_pull"),
                          value: "pull",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("tablePageSize") &&
                        _vm.sizeForm.tablePageMode === "page",
                      expression:
                        "showProperty('tablePageSize')&&sizeForm.tablePageMode === 'page'",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_page_size"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.table_page_size") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tablePageSize")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tablePageSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tablePageSize", $$v)
                        },
                        expression: "sizeForm.tablePageSize",
                      },
                    },
                    _vm._l(_vm.pageSizeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableTitleFontSize"),
                      expression: "showProperty('tableTitleFontSize')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_title_fontsize"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("chart.table_title_fontsize"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tableTitleFontSize")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tableTitleFontSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tableTitleFontSize", $$v)
                        },
                        expression: "sizeForm.tableTitleFontSize",
                      },
                    },
                    _vm._l(_vm.fontSize, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableItemFontSize"),
                      expression: "showProperty('tableItemFontSize')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_item_fontsize"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("chart.table_item_fontsize"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tableItemFontSize")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tableItemFontSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tableItemFontSize", $$v)
                        },
                        expression: "sizeForm.tableItemFontSize",
                      },
                    },
                    _vm._l(_vm.fontSize, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableHeaderAlign"),
                      expression: "showProperty('tableHeaderAlign')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_header_align"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("chart.table_header_align"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tableHeaderAlign")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tableHeaderAlign,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tableHeaderAlign", $$v)
                        },
                        expression: "sizeForm.tableHeaderAlign",
                      },
                    },
                    _vm._l(_vm.alignOptions, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableItemAlign"),
                      expression: "showProperty('tableItemAlign')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_item_align"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.table_item_align") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tableItemAlign")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tableItemAlign,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tableItemAlign", $$v)
                        },
                        expression: "sizeForm.tableItemAlign",
                      },
                    },
                    _vm._l(_vm.alignOptions, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableTitleHeight"),
                      expression: "showProperty('tableTitleHeight')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_title_height"),
                  },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      min: 20,
                      max: 100,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("tableTitleHeight")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.tableTitleHeight,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "tableTitleHeight", $$v)
                      },
                      expression: "sizeForm.tableTitleHeight",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableItemHeight"),
                      expression: "showProperty('tableItemHeight')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_item_height"),
                  },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      min: 20,
                      max: 100,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("tableItemHeight")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.tableItemHeight,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "tableItemHeight", $$v)
                      },
                      expression: "sizeForm.tableItemHeight",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableColumnMode"),
                      expression: "showProperty('tableColumnMode')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_column_width_config"),
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tableColumnMode")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tableColumnMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tableColumnMode", $$v)
                        },
                        expression: "sizeForm.tableColumnMode",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "adapt" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chart.table_column_adapt"))),
                        ]),
                      ]),
                      _c("el-radio", { attrs: { label: "custom" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chart.table_column_custom"))),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "bottom" },
                    },
                    [
                      _c("div", {
                        attrs: { slot: "content" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("chart.table_column_width_tip")
                          ),
                        },
                        slot: "content",
                      }),
                      _c("i", {
                        staticClass: "el-icon-info",
                        staticStyle: {
                          cursor: "pointer",
                          color: "#606266",
                          "margin-left": "4px",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("tableColumnMode") &&
                        _vm.sizeForm.tableColumnMode === "custom",
                      expression:
                        "showProperty('tableColumnMode') && sizeForm.tableColumnMode === 'custom'",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: "", "label-width": "100px" },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      min: 10,
                      max: 500,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("tableColumnWidth")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.tableColumnWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "tableColumnWidth", $$v)
                      },
                      expression: "sizeForm.tableColumnWidth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("showIndex"),
                      expression: "showProperty('showIndex')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_show_index"),
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { "input-size": "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("showIndex")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.showIndex,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "showIndex", $$v)
                        },
                        expression: "sizeForm.showIndex",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v(_vm._s(_vm.$t("panel.yes"))),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v(_vm._s(_vm.$t("panel.no"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("indexLabel") &&
                        _vm.sizeForm.showIndex,
                      expression:
                        "showProperty('indexLabel') && sizeForm.showIndex",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_index_desc"),
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    on: {
                      blur: function ($event) {
                        return _vm.changeBarSizeCase("indexLabel")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.indexLabel,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "indexLabel", $$v)
                      },
                      expression: "sizeForm.indexLabel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("mix"),
                      expression: "showProperty('mix')",
                    },
                  ],
                },
                [
                  _c(
                    "el-divider",
                    {
                      staticClass: "divider-style",
                      attrs: { "content-position": "center" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.chart_bar")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.adapt") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("barDefault")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.barDefault,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "barDefault", $$v)
                            },
                            expression: "sizeForm.barDefault",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.adapt")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.bar_gap") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          disabled: _vm.sizeForm.barDefault,
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 5,
                          step: 0.1,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("barGap")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.barGap,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "barGap", $$v)
                          },
                          expression: "sizeForm.barGap",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-divider",
                    {
                      staticClass: "divider-style",
                      attrs: { "content-position": "center" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.chart_line")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.line_width") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 10,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("lineWidth")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.lineWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "lineWidth", $$v)
                          },
                          expression: "sizeForm.lineWidth",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.line_symbol") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.line_symbol") },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("lineSymbol")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.lineSymbol,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "lineSymbol", $$v)
                            },
                            expression: "sizeForm.lineSymbol",
                          },
                        },
                        _vm._l(_vm.lineSymbolOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.line_symbol_size") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 20,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("lineSymbolSize")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.lineSymbolSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "lineSymbolSize", $$v)
                          },
                          expression: "sizeForm.lineSymbolSize",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.line_smooth") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("lineSmooth")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.lineSmooth,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "lineSmooth", $$v)
                            },
                            expression: "sizeForm.lineSmooth",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("chart.line_smooth")) + "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-divider",
                    {
                      staticClass: "divider-style",
                      attrs: { "content-position": "center" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.chart_scatter")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.bubble_symbol") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.line_symbol") },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("scatterSymbol")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.scatterSymbol,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "scatterSymbol", $$v)
                            },
                            expression: "sizeForm.scatterSymbol",
                          },
                        },
                        _vm._l(_vm.lineSymbolOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.bubble_size") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 1,
                          max: 40,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("scatterSymbolSize")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.scatterSymbolSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "scatterSymbolSize", $$v)
                          },
                          expression: "sizeForm.scatterSymbolSize",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "sizeFormGauge",
              attrs: {
                model: _vm.sizeForm,
                "label-width": "100px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeMin"),
                      expression: "showProperty('gaugeMin')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.min") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.changeQuotaField("min")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.gaugeMinType,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "gaugeMinType", $$v)
                        },
                        expression: "sizeForm.gaugeMinType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "fix" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.fix"))),
                      ]),
                      _c("el-radio-button", { attrs: { label: "dynamic" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.dynamic"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showProperty("gaugeMin") &&
              _vm.sizeForm.gaugeMinType === "fix"
                ? _c(
                    "el-form-item",
                    { staticClass: "form-item form-item-slider" },
                    [
                      _c("el-input-number", {
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("gaugeMin")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.gaugeMin,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "gaugeMin", $$v)
                          },
                          expression: "sizeForm.gaugeMin",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showProperty("gaugeMin") &&
              _vm.sizeForm.gaugeMinType === "dynamic"
                ? _c(
                    "el-form-item",
                    { staticClass: "form-item form-flex" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.field") },
                          on: {
                            change: function ($event) {
                              return _vm.changeQuotaField("min", true)
                            },
                          },
                          model: {
                            value: _vm.sizeForm.gaugeMinField.id,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm.gaugeMinField, "id", $$v)
                            },
                            expression: "sizeForm.gaugeMinField.id",
                          },
                        },
                        _vm._l(_vm.quotaData, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { float: "left" } },
                                [
                                  item.deType === 0
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-text",
                                        attrs: { "icon-class": "field_text" },
                                      })
                                    : _vm._e(),
                                  item.deType === 1
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-time",
                                        attrs: { "icon-class": "field_time" },
                                      })
                                    : _vm._e(),
                                  item.deType === 2 || item.deType === 3
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-value",
                                        attrs: { "icon-class": "field_value" },
                                      })
                                    : _vm._e(),
                                  item.deType === 5
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-location",
                                        attrs: {
                                          "icon-class": "field_location",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    color: "#8492a6",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.summary") },
                          on: {
                            change: function ($event) {
                              return _vm.changeQuotaField("min")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.gaugeMinField.summary,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm.gaugeMinField,
                                "summary",
                                $$v
                              )
                            },
                            expression: "sizeForm.gaugeMinField.summary",
                          },
                        },
                        [
                          _vm.validMinField
                            ? _c("el-option", {
                                key: "sum",
                                attrs: {
                                  value: "sum",
                                  label: _vm.$t("chart.sum"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMinField
                            ? _c("el-option", {
                                key: "avg",
                                attrs: {
                                  value: "avg",
                                  label: _vm.$t("chart.avg"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMinField
                            ? _c("el-option", {
                                key: "max",
                                attrs: {
                                  value: "max",
                                  label: _vm.$t("chart.max"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMinField
                            ? _c("el-option", {
                                key: "min",
                                attrs: {
                                  value: "min",
                                  label: _vm.$t("chart.min"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMinField
                            ? _c("el-option", {
                                key: "stddev_pop",
                                attrs: {
                                  value: "stddev_pop",
                                  label: _vm.$t("chart.stddev_pop"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMinField
                            ? _c("el-option", {
                                key: "var_pop",
                                attrs: {
                                  value: "var_pop",
                                  label: _vm.$t("chart.var_pop"),
                                },
                              })
                            : _vm._e(),
                          _c("el-option", {
                            key: "count",
                            attrs: {
                              value: "count",
                              label: _vm.$t("chart.count"),
                            },
                          }),
                          _vm.minField.id !== "count"
                            ? _c("el-option", {
                                key: "count_distinct",
                                attrs: {
                                  value: "count_distinct",
                                  label: _vm.$t("chart.count_distinct"),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeMax"),
                      expression: "showProperty('gaugeMax')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.max") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.changeQuotaField("max")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.gaugeMaxType,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "gaugeMaxType", $$v)
                        },
                        expression: "sizeForm.gaugeMaxType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "fix" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.fix"))),
                      ]),
                      _c("el-radio-button", { attrs: { label: "dynamic" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.dynamic"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showProperty("gaugeMax") &&
              _vm.sizeForm.gaugeMaxType === "fix"
                ? _c(
                    "el-form-item",
                    { staticClass: "form-item form-item-slider" },
                    [
                      _c("el-input-number", {
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("gaugeMax")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.gaugeMax,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "gaugeMax", $$v)
                          },
                          expression: "sizeForm.gaugeMax",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showProperty("gaugeMax") &&
              _vm.sizeForm.gaugeMaxType === "dynamic"
                ? _c(
                    "el-form-item",
                    { staticClass: "form-item form-flex" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.field") },
                          on: {
                            change: function ($event) {
                              return _vm.changeQuotaField("max", true)
                            },
                          },
                          model: {
                            value: _vm.sizeForm.gaugeMaxField.id,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm.gaugeMaxField, "id", $$v)
                            },
                            expression: "sizeForm.gaugeMaxField.id",
                          },
                        },
                        _vm._l(_vm.quotaData, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { float: "left" } },
                                [
                                  item.deType === 0
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-text",
                                        attrs: { "icon-class": "field_text" },
                                      })
                                    : _vm._e(),
                                  item.deType === 1
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-time",
                                        attrs: { "icon-class": "field_time" },
                                      })
                                    : _vm._e(),
                                  item.deType === 2 || item.deType === 3
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-value",
                                        attrs: { "icon-class": "field_value" },
                                      })
                                    : _vm._e(),
                                  item.deType === 5
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-location",
                                        attrs: {
                                          "icon-class": "field_location",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    color: "#8492a6",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.summary") },
                          on: {
                            change: function ($event) {
                              return _vm.changeQuotaField("max")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.gaugeMaxField.summary,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm.gaugeMaxField,
                                "summary",
                                $$v
                              )
                            },
                            expression: "sizeForm.gaugeMaxField.summary",
                          },
                        },
                        [
                          _vm.validMaxField
                            ? _c("el-option", {
                                key: "sum",
                                attrs: {
                                  value: "sum",
                                  label: _vm.$t("chart.sum"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMaxField
                            ? _c("el-option", {
                                key: "avg",
                                attrs: {
                                  value: "avg",
                                  label: _vm.$t("chart.avg"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMaxField
                            ? _c("el-option", {
                                key: "max",
                                attrs: {
                                  value: "max",
                                  label: _vm.$t("chart.max"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMaxField
                            ? _c("el-option", {
                                key: "min",
                                attrs: {
                                  value: "min",
                                  label: _vm.$t("chart.min"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMaxField
                            ? _c("el-option", {
                                key: "stddev_pop",
                                attrs: {
                                  value: "stddev_pop",
                                  label: _vm.$t("chart.stddev_pop"),
                                },
                              })
                            : _vm._e(),
                          _vm.validMaxField
                            ? _c("el-option", {
                                key: "var_pop",
                                attrs: {
                                  value: "var_pop",
                                  label: _vm.$t("chart.var_pop"),
                                },
                              })
                            : _vm._e(),
                          _c("el-option", {
                            key: "count",
                            attrs: {
                              value: "count",
                              label: _vm.$t("chart.count"),
                            },
                          }),
                          _vm.maxField.id !== "count"
                            ? _c("el-option", {
                                key: "count_distinct",
                                attrs: {
                                  value: "count_distinct",
                                  label: _vm.$t("chart.count_distinct"),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeStartAngle"),
                      expression: "showProperty('gaugeStartAngle')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.start_angle") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: -360,
                      max: 360,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("gaugeStartAngle")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.gaugeStartAngle,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "gaugeStartAngle", $$v)
                      },
                      expression: "sizeForm.gaugeStartAngle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeEndAngle"),
                      expression: "showProperty('gaugeEndAngle')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.end_angle") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: -360,
                      max: 360,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("gaugeEndAngle")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.gaugeEndAngle,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "gaugeEndAngle", $$v)
                      },
                      expression: "sizeForm.gaugeEndAngle",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "sizeFormPie",
              attrs: {
                model: _vm.sizeForm,
                "label-width": "100px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaFontSize"),
                      expression: "showProperty('quotaFontSize')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.quota_font_size") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.quota_font_size") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontSize")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontSize", $$v)
                        },
                        expression: "sizeForm.quotaFontSize",
                      },
                    },
                    _vm._l(_vm.fontSize, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaFontFamily"),
                      expression: "showProperty('quotaFontFamily')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.quota_font_family") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.quota_font_family") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontFamily")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontFamily,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontFamily", $$v)
                        },
                        expression: "sizeForm.quotaFontFamily",
                      },
                    },
                    _vm._l(_vm.fontFamily, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaFontStyle"),
                      expression: "showProperty('quotaFontStyle')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.quota_text_style") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontIsItalic")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontIsItalic,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontIsItalic", $$v)
                        },
                        expression: "sizeForm.quotaFontIsItalic",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.italic")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontIsBolder")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontIsBolder,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontIsBolder", $$v)
                        },
                        expression: "sizeForm.quotaFontIsBolder",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.bolder")))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaLetterSpace"),
                      expression: "showProperty('quotaLetterSpace')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.quota_letter_space") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("chart.quota_letter_space"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaLetterSpace")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaLetterSpace,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaLetterSpace", $$v)
                        },
                        expression: "sizeForm.quotaLetterSpace",
                      },
                    },
                    _vm._l(_vm.fontLetterSpace, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaFontShadow"),
                      expression: "showProperty('quotaFontShadow')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.font_shadow") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontShadow")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontShadow,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontShadow", $$v)
                        },
                        expression: "sizeForm.quotaFontShadow",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.font_shadow")))]
                  ),
                ],
                1
              ),
              _vm.showProperty("dimensionShow") ? _c("el-divider") : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("dimensionShow"),
                      expression: "showProperty('dimensionShow')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.dimension_show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("dimensionShow")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.dimensionShow,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "dimensionShow", $$v)
                        },
                        expression: "sizeForm.dimensionShow",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.sizeForm.dimensionShow,
                      expression: "sizeForm.dimensionShow",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionFontSize"),
                          expression: "showProperty('dimensionFontSize')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_font_size") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.dimension_font_size"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("dimensionFontSize")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontSize,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "dimensionFontSize", $$v)
                            },
                            expression: "sizeForm.dimensionFontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionFontFamily"),
                          expression: "showProperty('dimensionFontFamily')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_font_family") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.dimension_font_family"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionFontFamily"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontFamily,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "dimensionFontFamily", $$v)
                            },
                            expression: "sizeForm.dimensionFontFamily",
                          },
                        },
                        _vm._l(_vm.fontFamily, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionFontStyle"),
                          expression: "showProperty('dimensionFontStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_text_style") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionFontIsItalic"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontIsItalic,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm,
                                "dimensionFontIsItalic",
                                $$v
                              )
                            },
                            expression: "sizeForm.dimensionFontIsItalic",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.italic")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionFontIsBolder"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontIsBolder,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm,
                                "dimensionFontIsBolder",
                                $$v
                              )
                            },
                            expression: "sizeForm.dimensionFontIsBolder",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.bolder")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionLetterSpace"),
                          expression: "showProperty('dimensionLetterSpace')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_letter_space") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.dimension_letter_space"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionLetterSpace"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionLetterSpace,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm,
                                "dimensionLetterSpace",
                                $$v
                              )
                            },
                            expression: "sizeForm.dimensionLetterSpace",
                          },
                        },
                        _vm._l(_vm.fontLetterSpace, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionFontShadow"),
                          expression: "showProperty('dimensionFontShadow')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.font_shadow") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionFontShadow"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontShadow,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "dimensionFontShadow", $$v)
                            },
                            expression: "sizeForm.dimensionFontShadow",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.font_shadow")))]
                      ),
                    ],
                    1
                  ),
                  _vm.showProperty("spaceSplit") ? _c("el-divider") : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("spaceSplit"),
                          expression: "showProperty('spaceSplit')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.space_split") },
                    },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("spaceSplit")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.spaceSplit,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "spaceSplit", $$v)
                          },
                          expression: "sizeForm.spaceSplit",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("hPosition"),
                          expression: "showProperty('hPosition')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.h_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.h_position") },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("hPosition")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.hPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "hPosition", $$v)
                            },
                            expression: "sizeForm.hPosition",
                          },
                        },
                        [
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "start",
                                label: _vm.$t("chart.p_left"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_left")))]
                          ),
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "center",
                                label: _vm.$t("chart.p_center"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_center")))]
                          ),
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "end",
                                label: _vm.$t("chart.p_right"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_right")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("vPosition"),
                          expression: "showProperty('vPosition')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.v_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.v_position") },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("vPosition")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.vPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "vPosition", $$v)
                            },
                            expression: "sizeForm.vPosition",
                          },
                        },
                        [
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "start",
                                label: _vm.$t("chart.p_top"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_top")))]
                          ),
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "center",
                                label: _vm.$t("chart.p_center"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_center")))]
                          ),
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "end",
                                label: _vm.$t("chart.p_bottom"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_bottom")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("scatterSymbol"),
                      expression: "showProperty('scatterSymbol')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.bubble_symbol") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.line_symbol") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("scatterSymbol")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.scatterSymbol,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "scatterSymbol", $$v)
                        },
                        expression: "sizeForm.scatterSymbol",
                      },
                    },
                    _vm._l(_vm.lineSymbolOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("scatterSymbolSize"),
                      expression: "showProperty('scatterSymbolSize')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.bubble_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 1,
                      max: 40,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("scatterSymbolSize")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.scatterSymbolSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "scatterSymbolSize", $$v)
                      },
                      expression: "sizeForm.scatterSymbolSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidShape"),
                      expression: "showProperty('liquidShape')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.liquid_shape") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.liquid_shape") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("liquidShape")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.liquidShape,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "liquidShape", $$v)
                        },
                        expression: "sizeForm.liquidShape",
                      },
                    },
                    _vm._l(_vm.liquidShapeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidMax"),
                      expression: "showProperty('liquidMax')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.liquid_max") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.changeQuotaField("max")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.liquidMaxType,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "liquidMaxType", $$v)
                        },
                        expression: "sizeForm.liquidMaxType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "fix" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.fix"))),
                      ]),
                      _c("el-radio-button", { attrs: { label: "dynamic" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.dynamic"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showProperty("liquidMax") &&
              _vm.sizeForm.liquidMaxType === "fix"
                ? _c(
                    "el-form-item",
                    { staticClass: "form-item form-item-slider" },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("liquidMax")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.liquidMax,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "liquidMax", $$v)
                          },
                          expression: "sizeForm.liquidMax",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showProperty("liquidMax") &&
              _vm.sizeForm.liquidMaxType === "dynamic"
                ? _c(
                    "el-form-item",
                    { staticClass: "form-item form-flex" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.field") },
                          on: {
                            change: function ($event) {
                              return _vm.changeQuotaField("max", true)
                            },
                          },
                          model: {
                            value: _vm.sizeForm.liquidMaxField.id,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm.liquidMaxField, "id", $$v)
                            },
                            expression: "sizeForm.liquidMaxField.id",
                          },
                        },
                        _vm._l(_vm.quotaData, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { float: "left" } },
                                [
                                  item.deType === 0
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-text",
                                        attrs: { "icon-class": "field_text" },
                                      })
                                    : _vm._e(),
                                  item.deType === 1
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-time",
                                        attrs: { "icon-class": "field_time" },
                                      })
                                    : _vm._e(),
                                  item.deType === 2 || item.deType === 3
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-value",
                                        attrs: { "icon-class": "field_value" },
                                      })
                                    : _vm._e(),
                                  item.deType === 5
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-location",
                                        attrs: {
                                          "icon-class": "field_location",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    color: "#8492a6",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.summary") },
                          on: {
                            change: function ($event) {
                              return _vm.changeQuotaField("max")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.liquidMaxField.summary,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm.liquidMaxField,
                                "summary",
                                $$v
                              )
                            },
                            expression: "sizeForm.liquidMaxField.summary",
                          },
                        },
                        [
                          _vm.validLiquidMaxField
                            ? _c("el-option", {
                                key: "sum",
                                attrs: {
                                  value: "sum",
                                  label: _vm.$t("chart.sum"),
                                },
                              })
                            : _vm._e(),
                          _vm.validLiquidMaxField
                            ? _c("el-option", {
                                key: "avg",
                                attrs: {
                                  value: "avg",
                                  label: _vm.$t("chart.avg"),
                                },
                              })
                            : _vm._e(),
                          _vm.validLiquidMaxField
                            ? _c("el-option", {
                                key: "max",
                                attrs: {
                                  value: "max",
                                  label: _vm.$t("chart.max"),
                                },
                              })
                            : _vm._e(),
                          _vm.validLiquidMaxField
                            ? _c("el-option", {
                                key: "min",
                                attrs: {
                                  value: "min",
                                  label: _vm.$t("chart.min"),
                                },
                              })
                            : _vm._e(),
                          _vm.validLiquidMaxField
                            ? _c("el-option", {
                                key: "stddev_pop",
                                attrs: {
                                  value: "stddev_pop",
                                  label: _vm.$t("chart.stddev_pop"),
                                },
                              })
                            : _vm._e(),
                          _vm.validLiquidMaxField
                            ? _c("el-option", {
                                key: "var_pop",
                                attrs: {
                                  value: "var_pop",
                                  label: _vm.$t("chart.var_pop"),
                                },
                              })
                            : _vm._e(),
                          _c("el-option", {
                            key: "count",
                            attrs: {
                              value: "count",
                              label: _vm.$t("chart.count"),
                            },
                          }),
                          _vm.liquidMaxField.id !== "count"
                            ? _c("el-option", {
                                key: "count_distinct",
                                attrs: {
                                  value: "count_distinct",
                                  label: _vm.$t("chart.count_distinct"),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidSize"),
                      expression: "showProperty('liquidSize')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.radar_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 1,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("liquidSize")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.liquidSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "liquidSize", $$v)
                      },
                      expression: "sizeForm.liquidSize",
                    },
                  }),
                ],
                1
              ),
              _vm.showProperty("symbolOpacity")
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.not_alpha") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 10,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("symbolOpacity")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.symbolOpacity,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "symbolOpacity", $$v)
                          },
                          expression: "sizeForm.symbolOpacity",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showProperty("symbolStrokeWidth") &&
              _vm.sizeForm.scatterSymbol &&
              _vm.sizeForm.scatterSymbol !== "marker"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("plugin_style.border") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 5,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("symbolStrokeWidth")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.symbolStrokeWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "symbolStrokeWidth", $$v)
                          },
                          expression: "sizeForm.symbolStrokeWidth",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }